module.exports = __webpack_public_path__ + "static/media/Artboard4.8cb16721.jpg";